/**
 * Navigation Block Functionality
 *
 * Handles mobile dropdown functionality for the navigation block.
 *
 * @package Karuna_Hospice
 */

/**
 * Initialize navigation dropdown functionality
 */
export function initNavigation() {
	const navigationDropdowns = document.querySelectorAll( '[data-navigation-dropdown]' );

	if ( ! navigationDropdowns.length ) {
		return;
	}

	navigationDropdowns.forEach( ( dropdown ) => {
		const button = dropdown.querySelector( '.navigation-block__dropdown-button' );
		const menu = dropdown.querySelector( '.navigation-block__dropdown-menu' );
		const selectedText = dropdown.querySelector( '.navigation-block__dropdown-selected' );
		const icon = dropdown.querySelector( '.navigation-block__dropdown-icon' );
		const links = dropdown.querySelectorAll( '.navigation-block__dropdown-item' );

		if ( ! button || ! menu || ! selectedText ) {
			return;
		}

		// Toggle dropdown on button click
		button.addEventListener( 'click', ( e ) => {
			e.stopPropagation();
			const isExpanded = button.getAttribute( 'aria-expanded' ) === 'true';

			if ( isExpanded ) {
				closeDropdown();
			} else {
				openDropdown();
			}
		} );

		// Handle link clicks
		links.forEach( ( link ) => {
			link.addEventListener( 'click', () => {
				const linkText = link.textContent.trim();
				selectedText.textContent = linkText;
				closeDropdown();
			} );
		} );

		// Close dropdown when clicking outside
		document.addEventListener( 'click', ( e ) => {
			if ( ! dropdown.contains( e.target ) ) {
				closeDropdown();
			}
		} );

		// Close dropdown on escape key
		document.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'Escape' && button.getAttribute( 'aria-expanded' ) === 'true' ) {
				closeDropdown();
				button.focus();
			}
		} );

		function openDropdown() {
			menu.classList.remove( 'hidden' );
			button.setAttribute( 'aria-expanded', 'true' );
			if ( icon ) {
				icon.style.transform = 'rotate(180deg)';
			}
		}

		function closeDropdown() {
			menu.classList.add( 'hidden' );
			button.setAttribute( 'aria-expanded', 'false' );
			if ( icon ) {
				icon.style.transform = 'rotate(0deg)';
			}
		}
	} );
}

